import React, { Component } from "react";
import styles from "./CatalogManagement.module.scss";
import { withTranslation } from "react-i18next";
import CatalogHeader from "./CatalogHeader";
import CatalogsList from "./CatalogsList";
import { Button } from "@material-ui/core";
import AddNewCatalog from "./AddNewCatalog";

class CatalogDetails extends Component {
  constructor(props) {
    super(props);
    this.state = { openNewCatalog: false };
  }

  toggleNewCatalog = () => {
    this.setState((prevState) => ({
      openNewCatalog: !prevState.openNewCatalog,
    }));
  };

  render() {
    return this.props.catalogIds && this.props.catalogIds.length > 0 ? (
      <div>
        <CatalogHeader
          {...this.props}
          sortKey={this.props.sortKey}
          sortDirection={this.props.sortDirection}
          sortCatalogsData={this.props.sortCatalogsData}
        />

        <CatalogsList
          {...this.props}
          catalogIds={this.props.catalogIds}
          numberOfRows={this.props.catalogIds.length}
        />
        <div className={styles.moduleWrapper}>
          <Button
            className={styles.addNewCatalogButton}
            onClick={this.toggleNewCatalog}
          >
            ADD NEW CATALOG
          </Button>
        </div>
        <AddNewCatalog
          open={this.state.openNewCatalog}
          closeModal={this.toggleNewCatalog}
          user={this.props.user}
          {...this.props}
        />
      </div>
    ) : (
      <span className={styles.dataNotFound}>
        {" "}
        {this.props.t("Error.dataNotFound")}
      </span>
    );
  }
}

export default withTranslation("emp")(CatalogDetails);
